const TeamActions = {
  TEAM_LOADED: "team/loaded",
};

export default TeamActions;
